// Box arithmetic by axis index, shared by the movement guides, butting and
// the component geometry. A leaf, like axes.ts.
import * as THREE from 'three';

/**
 * @param {THREE.Box3} a A box.
 * @param {THREE.Box3} b Another.
 * @param {number} axis An axis index.
 * @return {number} How far they overlap along it; negative for a gap.
 */
export const overlapOn = (a: THREE.Box3, b: THREE.Box3, axis: number): number =>
    Math.min(a.max.getComponent(axis), b.max.getComponent(axis)) -
    Math.max(a.min.getComponent(axis), b.min.getComponent(axis));

/**
 * @param {THREE.Box3} box A box.
 * @return {number} The axis index it is thinnest along.
 */
export const thinnestAxis = (box: THREE.Box3): number => {
    const size = box.getSize(new THREE.Vector3());

    return [0, 1, 2].reduce((best, index) =>
        size.getComponent(index) < size.getComponent(best) ? index : best
    );
};

/**
 * @param {THREE.Box3} box A box.
 * @param {number} axis The axis index to flatten it on.
 * @param {number} at Where on that axis.
 * @return {THREE.Box3} A copy, flattened there.
 */
export const flattenBox = (
    box: THREE.Box3,
    axis: number,
    at: number
): THREE.Box3 => {
    const flat = box.clone();
    flat.min.setComponent(axis, at);
    flat.max.setComponent(axis, at);

    return flat;
};
